import { useLocale } from "@hooks/use-locale"
import COUNTRIES from "@content/countries.json"

const Country = () => {
  const { locale } = useLocale()
  const countryLocale = locale !== "ja" ? "en-US" : "ja"
  const countries = COUNTRIES[countryLocale.toLowerCase()]

  if (countries) {
    return Object.keys(countries).map((key) => {
      return <option aria-label={countries[key]} key={key} value={key} label={countries[key]} />
    })
  }
  return <option aria-label={countries[null]} />
}

export const countryJSON = (locale) => {
  const countryLocale = locale !== "ja" ? "en-US" : "ja"
  const countries = COUNTRIES[countryLocale.toLowerCase()]

  if (countries) {
    return Object.keys(countries).map((key) => {
      return { value: key, display: countries[key] }
    })
  }
  return {}
}

export default Country
